import React, { useEffect } from "react";
import moment from "moment-mini";
import { compose } from "redux";
import { globalConfigFields } from "../../../../../redux/modules/globalConfig";
import withAffiliateProgram from "../../../../../hocs/withAffiliateProgram";
import withAffiliateProgramForm from "../../../../../hocs/withAffiliateProgramForm";
import withGlobalConfigFields from "../../../../../hocs/withGlobalConfigFields";
import SquaberTable from "../../../common/SquaberTable";
import ContentSection from "../../../common/ContentSection";
import Loader from "../../../common/Loader/modules/default";
import SquaberTooltip from "../../../common/SquaberTooltip";
import Page404 from "../../../pages/Page404";

import "../styles/default.scss";

function AffiliateProgram({
  translate,
  affiliateProgram,
  getAffiliateDetails,
  getAffiliateHistory,
  globalConfig,
  canShowAffiliateProgram
}) {
  useEffect(() => {
    getAffiliateHistory();
  }, [getAffiliateDetails, getAffiliateHistory]);

  const { affiliationTermsAndConditionsPdf } = globalConfig;

  const {
    detailsLoading,
    historyLoading,
    history = [],
    details
  } = affiliateProgram;
  const isLoading = detailsLoading || historyLoading;

  const {
    amount_of_points: amountOfPoints = 0,
    amount_of_pending_points: amountOfPendingPoints = 0
  } = details || {};

  const hasHistory = Array.isArray(history) && history.length > 0;

  return (
    <div className="relation-program">
      {isLoading ? (
        <Loader />
      ) : !canShowAffiliateProgram ? (
        <ContentSection>
          <Page404 />
        </ContentSection>
      ) : (
        <>
          <ContentSection>
            <h1>{translate("affiliate-program_headline")}</h1>
            <p>{translate("affiliate-program_description")}</p>
            <h2>{translate("affiliate-program_what-it-means")}</h2>
            <ol>
              <li>{translate("affiliate-program_point-1")}</li>
              <li>
                <strong>
                  {translate("affiliate-program_points-safe-title")}
                </strong>{" "}
                {translate("affiliate-program_point-2")}
              </li>
            </ol>
            <h2 className={"no-margin-bottom"}>
              <span className={"points"}>
                {translate("Your Points")}: {amountOfPoints}
              </span>
              {amountOfPendingPoints ? (
                <SquaberTooltip title="pending-points-tooltip">
                  <span className="pending-points">
                    ({translate("pending-points")}: {amountOfPendingPoints})
                  </span>
                </SquaberTooltip>
              ) : null}
            </h2>
          </ContentSection>
          <ContentSection>
            <h2>{translate("headline-affiliate-history")}</h2>
            {hasHistory ? (
              <>
                <p>{translate("description-affiliate-history")}</p>
                <SquaberTable
                  withDistinctRows
                  heading={[
                    translate("Modified"),
                    translate("Created"),
                    translate("Description"),
                    translate("Points earned")
                  ]}
                  rows={history.map(
                    ({
                      balance_change: balanceChange,
                      description,
                      updated,
                      created
                    }) => {
                      return [
                        updated ? moment(updated).format("DD.MM.YYYY") : "",
                        created ? moment(created).format("DD.MM.YYYY") : "",
                        description || "",
                        balanceChange || ""
                      ];
                    }
                  )}
                />
              </>
            ) : (
              <p className="no-margin-bottom">
                {translate("secondary-description-affiliate-history")}
              </p>
            )}
          </ContentSection>
          <ContentSection>
            <p className="no-margin-bottom">
              <a href={affiliationTermsAndConditionsPdf} target="_blank">
                {translate("Download regulations document")}
              </a>
            </p>
          </ContentSection>
        </>
      )}
    </div>
  );
}

export default compose(
  withGlobalConfigFields([
    globalConfigFields.AFFILIATE_PROGRAM_TERMS_AND_CONDITIONS,
    globalConfigFields.AFFILIATE_PROGRAM_TERMS_AND_CONDITIONS_PDF
  ]),
  withAffiliateProgramForm,
  withAffiliateProgram
)(AffiliateProgram);
